import { useEffect, useEffectEvent } from 'react';

import { useNavigate } from 'react-router';

import { clock } from '@/services/clock';
import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';

export const useTokenExpiry = () => {
  const navigate = useNavigate();
  const gxToken = useStorageValue(StorageKeys.GxToken);
  const expiryTime = useStorageValue(StorageKeys.TokenExpiry);

  const isExpired = useEffectEvent(() => {
    if (!expiryTime) return true;

    const now = Math.floor(clock.now() / 1000);
    const timeUntilExpiry = expiryTime - now;

    return timeUntilExpiry <= 0;
  });

  useEffect(() => {
    if (!gxToken) {
      return;
    }
    if (isExpired()) {
      navigate('/logout');
      return;
    }

    const interval = setInterval(() => {
      if (isExpired()) {
        navigate('/logout');
      }
    }, 6000);

    return () => {
      clearInterval(interval);
    };
  }, [navigate, gxToken]);
};
